import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Select from "react-select";

import {
    Form,
    Card,
    Container,
    Row,
    Col,
    Alert,
    Button,
} from "react-bootstrap";
import { faFileExcel } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Search } from "react-feather";
import download from "downloadjs";

import { tableColumns } from "./Data.js";
import { Lists } from "./Lists.js";
import api from "../../../service/api.js";
import moment from "moment";

const PassingRate = ({ status, title }) => {
    /** Permissions */
    // !THIS LINE IS NEVER USED!!!
    // const permissionData = useSelector((state) => {
    //     return state.user ? state.user : state;
    // });
    // const permission = permissionData?.data?.permissions;
    /** Permissions */

    const { state } = useLocation();
    const previousSearchValue = state?.previousSearchValue || null;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);

    // FILTER STATES
    const [selectedDate, setSelectedDate] = useState(
        previousSearchValue?.date ||  moment().format("YYYY-MM")
    );
    const [selectedTradeCategory, setSelectedTradeCategory] = useState(
        previousSearchValue?.course_id || null
    );
    const [options, setOptions] = useState([]);

    const [notif, setNotif] = useState({
        notifMsg: "",
        open: false,
        severity: "success",
    });

    // This logic shows all the data [Initially not filtered]
    const getPassingData = useCallback(async (filters) => {
        setLoading(true);
        try {
            // TODO: add additional filter parameters if necessary
            const params = {};
            if (filters.date) {
                params.date = filters.date;
            }
            if (filters.course_id) {
                params.course_id = filters.course_id;
            }

            // ? GET: filtered data
            const response = await api.get("tms/passing-rate-summary", params);
            setData(response);
            setError();
        } catch (error) {
            setLoading(false);
            setError(error.message);
            setData([]);
        }
        setLoading(false);
    }, []);

    // ? This gets the values for the trade category from courses resource
    const getTradeCategory = useCallback(async () => {
        try {
            const response = await api.get("tms/courses");

            // Map the values of the options [Only get the id and the names]
            const selectOptions = response.data.map((data) => ({
                value: data.id,
                label: data.name,
            }));
            setOptions(selectOptions);
        } catch (error) {
            setError(error.message);
        }
    }, []);

    // ? This will mount the options on initial load
    useEffect(() => {
        getTradeCategory();
    }, [getTradeCategory]);

    // ? Search button handler
    const handleSearch = () => {
        const filters = {
            date: selectedDate,
            course_id: selectedTradeCategory,
        };
        getPassingData(filters);
    };

    // !! This Exports all data initially without filter [I dunno what happens in 10K+ data]
    const generateExcelFile = async () => {
        setIsSubmitting(true);
        try {
            // ? Filter data that will only be exported
            const params = {};
            if (selectedDate) {
                params.date = selectedDate;
            }
            if (selectedTradeCategory) {
                params.course_id = selectedTradeCategory;
            }

            // ? Exports filtered data
            const response = await api.getexcel(
                "tms/passing-rate-summary/excel-export",
                params
            );

            if (response.type.includes("application/json")) {
                // ? Executes if there is no data to download
                const jsonData = JSON.parse(await response.text());

                setNotif({
                    notifMsg: jsonData.message,
                    open: true,
                    severity: jsonData.success ? "success" : "danger",
                });
            } else if (response.size !== 0) {
                // ? Executes when there is a data to download
                const dateLabel = selectedDate
                    ? `_${selectedDate}`
                    : "_All_Dates";
                const categoryLabel = selectedTradeCategory
                    ? `_${
                          options.find((o) => o.value === selectedTradeCategory)
                              ?.label || "filtered"
                      }`
                    : "";
                download(
                    response,
                    `Passing_Rate_Summary${dateLabel}${categoryLabel}`, // !! FILE NAME
                    "application/xlsx"
                );
            } else {
                // ? Fallback
                setError("No data to be exported.");
            }
        } catch (error) {
            setError(error.message);
        }
        setIsSubmitting(false);
    };

    // ? Sets all data on mount
    useEffect(() => {
        const filters = {
            date: selectedDate,
            course_id: selectedTradeCategory,
        };
        console.log("filters:", filters)
        getPassingData(filters);
    }, [getPassingData]); //  eslint-disable-line react-hooks/exhaustive-deps

    const helmetTitle = "Monthly Passing Rate";

    return (
        <React.Fragment>
            <Helmet title={helmetTitle} />
            <Container fluid className="p-0">
                <h1 className="h3 mb-3">{title}</h1>
                <Card>
                    <Card.Header>
                        {error && (
                            <Alert className="my-3" variant="danger">
                                <div className="alert-message">{error}</div>
                            </Alert>
                        )}
                        {notif.open && (
                            <Alert className="my-3" variant={notif.severity}>
                                <div className="alert-message">
                                    {notif.notifMsg}
                                </div>
                            </Alert>
                        )}
                        <Row className="g-2 g-md-3 align-items-center">
                            <Col md={4}>
                                <Form.Group controlId="formMonth">
                                    <Form.Control
                                        type="month"
                                        name="month"
                                        min="2022-01"
                                        max="2050-12"
                                        value={selectedDate}
                                        size="lg"
                                        onChange={(event) =>
                                            setSelectedDate(event.target.value)
                                        }
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Select
                                    className="react-select-container w-100"
                                    classNamePrefix="react-select"
                                    options={options}
                                    name="course_id"
                                    placeholder="Select trade category"
                                    value={
                                        options.find(
                                            (opt) =>
                                                opt.value ===
                                                selectedTradeCategory
                                        ) || null
                                    }
                                    onChange={(selected) =>
                                        setSelectedTradeCategory(
                                            selected?.value || null
                                        )
                                    }
                                    isClearable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: "30px",
                                        }),
                                    }}
                                />
                            </Col>

                            <Col
                                md={4}
                                className="d-flex justify-content-between justify-content-md-start"
                            >
                                <Button
                                    variant="info"
                                    type="button"
                                    size="lg"
                                    className="me-2"
                                    onClick={handleSearch}
                                >
                                    <Search className="feather" />
                                </Button>

                                {!isSubmitting ? (
                                    <Button
                                        variant="info"
                                        type="button"
                                        size="lg"
                                        onClick={generateExcelFile}
                                    >
                                        <FontAwesomeIcon icon={faFileExcel} />
                                    </Button>
                                ) : (
                                    <div
                                        className="spinner-border text-info"
                                        role="status"
                                        style={{
                                            width: "2rem",
                                            height: "2rem",
                                        }}
                                    >
                                        <span className="visually-hidden">
                                            Loading...
                                        </span>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="pt-0">
                        {loading && <div>Loading...</div>}
                        {!loading && data?.data && (
                            <Lists
                                getPassingData={getPassingData}
                                columns={tableColumns}
                                rawData={data}
                                status={status}
                                title={title}
                            />
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </React.Fragment>
    );
};

export default PassingRate;
